import CatalogSorting from '~/themes/base/components/catalog/CatalogSorting'

export default {
  extends: CatalogSorting,
  data() {
    const sortOptions =
      this.$themeSettings.components.CatalogSorting.options &&
      this.$themeSettings.components.CatalogSorting.options.length > 0
        ? this.$themeSettings.components.CatalogSorting.options
        : ['DefaultSort', 'MostSoldSort', 'PriceSortASC', 'PriceSortDESC']

    if (this.isSearch && !sortOptions.includes('SearchSort')) {
      sortOptions.push('SearchSort')
    }

    return {
      sortOptions,
    }
  },
}
